/// <reference types="vite/client" />

// Environment-specific configuration
const isDevelopment = import.meta.env.MODE === 'development';

interface Config {
  API_URL: string;
  API_KEY: string;
}

/**
 * Validates that required environment variables are present
 * @throws {Error} if any required variables are missing
 */
function validateConfig() {
  // Only validate in production mode
  if (!isDevelopment) {
    const required = ['VITE_AUTH_URL', 'VITE_X_API_KEY'];
    const missing = required.filter((key) => !import.meta.env[key]);

    if (missing.length > 0) {
      throw new Error(
        `Missing required environment variables: ${missing.join(', ')}`
      );
    }
  }
}

// Validate environment variables
validateConfig();

/**
 * Application configuration
 * @property {string} API_URL - Base URL for API endpoints
 * @property {string} API_KEY - API key for authentication
 */
export const config: Config = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  API_KEY: import.meta.env.VITE_X_API_KEY || 'development-key',
};
